/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Profile_LabelInputs */

const en_drastic_tech_profile_label = /** @type {(inputs: Drastic_Tech_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile`)
};

const fr_drastic_tech_profile_label = /** @type {(inputs: Drastic_Tech_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const de_drastic_tech_profile_label = /** @type {(inputs: Drastic_Tech_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const it_drastic_tech_profile_label = /** @type {(inputs: Drastic_Tech_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilo`)
};

const ru_drastic_tech_profile_label = /** @type {(inputs: Drastic_Tech_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профиль`)
};

const es_drastic_tech_profile_label = /** @type {(inputs: Drastic_Tech_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil`)
};

const zh_cn2_drastic_tech_profile_label = /** @type {(inputs: Drastic_Tech_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`轮廓`)
};

const ja_drastic_tech_profile_label = /** @type {(inputs: Drastic_Tech_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロフィール`)
};

const hi_drastic_tech_profile_label = /** @type {(inputs: Drastic_Tech_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोफ़ाइल`)
};

const pt_pt2_drastic_tech_profile_label = /** @type {(inputs: Drastic_Tech_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil`)
};

/**
* | output |
* | --- |
* | "Profile" |
*
* @param {Drastic_Tech_Profile_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_profile_label = /** @type {((inputs?: Drastic_Tech_Profile_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Profile_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_profile_label(inputs)
	if (locale === "de") return de_drastic_tech_profile_label(inputs)
	if (locale === "it") return it_drastic_tech_profile_label(inputs)
	if (locale === "ru") return ru_drastic_tech_profile_label(inputs)
	if (locale === "es") return es_drastic_tech_profile_label(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_profile_label(inputs)
	if (locale === "ja") return ja_drastic_tech_profile_label(inputs)
	if (locale === "hi") return hi_drastic_tech_profile_label(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_profile_label(inputs)
	return en_drastic_tech_profile_label(inputs)
});